import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { SettingsDebugAccountInfoForm } from "@/pages/settings/components/debug-account-info-form/settings-debug-account-info-form";
import { FC } from "react";

export const SettingsDebugAccountPage: FC = () => {
  return (
    <SettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Debug Account">
        <div>
          <SettingsDebugAccountInfoForm />
        </div>
      </SettingsSubsectionWrapper>
    </SettingsSectionWrapper>
  );
};
